import {useAppSelector} from "../../store/hook";
import React, {useEffect, useState} from "react";
import {WeatherModel} from "../../model/common/weatherModel";
import moment from "moment/moment";

export function convertWeatherIconToClass(icon: string): string {
  switch (icon) {
    case '01': return 'weather7';
    case '02': return 'weather3';
    case '03': return 'weather2';
    case '04': return 'weather1';
    case '09': return 'weather5';
    case '10': return 'weather8';
    case '11': return 'weather9';
    case '13': return 'weather6';
    case '50': return 'weather4';
    default: return '';
  }
}

export default function WeatherInfo() {
  const weathers = useAppSelector(state => state.weather.today);
  const [currentWeather, setCurrentWeather] = useState<WeatherModel>();

  useEffect(() => {
    if (weathers && weathers.length > 0) {
      const currentHour = moment().hour();
      const findHourWeather = weathers.find((weather) => {
        if (weather.dt && moment(weather.dt).hour() === currentHour) {
          return weather;
        }
      });
      setCurrentWeather(findHourWeather);
    }
  }, [weathers]);

  return (
    <div className="weather-box">
      <ul>
        <li>
          <span className={currentWeather ? convertWeatherIconToClass(currentWeather.weatherIcon) : ''}>
            <span className="hid">날씨 아이콘</span>
          </span>
          <strong className="txt">
            {currentWeather ? Math.round(currentWeather.temp) : '-'}˚C
          </strong>
        </li>
        <li>
          <span className="water-icon"><span className="hid">습도 아이콘</span></span>
          <strong className="txt">
            <em>습도</em>
            {currentWeather ? currentWeather.humidity : '-'}%
          </strong>
        </li>
      </ul>
    </div>
  );
}